import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const calendarSchema = new schema.Entity(
  'calendars',
  {},
  {
    idAttribute: 'id',
  }
)

export const calendarLiturgicalTextSchema = new schema.Entity(
  'calendar_liturgical_texts',
  {},
  {
    idAttribute: 'id',
  }
)

export const calendarLiturgicalEventSchema = new schema.Entity(
  'calendar_liturgical_events',
  {},
  {
    idAttribute: 'id',
  }
)

export const calendar_getCalendarDates_Api = {
  backend: `Route::get('calendars/year/{year}/gets', 'CalendarController@getCalendarDates');`,
  root: API_ROOT_URL,
  path: '/calendars/year/:year/gets',
  method: 'GET',
}

export const calendar_getCalendarById_Api = {
  backend: `Route::get('calendars/calendar/{calendar_id}/get', 'CalendarController@getById');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar/:id/get',
  method: 'GET',
  paramsFields: ['language'],
  schema: calendarSchema,
  transform: createTransform(calendarSchema, 'data'),
}

export const calendar_getCalendarLiturgicalTexts_Api = {
  backend: `Route::get('calendars/calendar/{calendar_id}/calendar-liturgical-text/gets', 'CalendarController@getCalendarLiturgicalTexts');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar/:calendar_id/calendar-liturgical-text/gets',
  method: 'GET',
  paramsFields: [],
  schema: calendarLiturgicalTextSchema,
  transform: createListTransform(calendarLiturgicalTextSchema),
}

export const calendar_createLiturgicalText_Api = {
  backend: `Route::post('calendars/calendar/{calendar_id}/calendar-liturgical-text/create', 'CalendarController@createLiturgicalText');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar/:calendar_id/calendar-liturgical-text/create',
  method: 'POST',
  paramsFields: [],
  schema: calendarLiturgicalTextSchema,
  transform: createTransform(calendarLiturgicalTextSchema, 'data'),
}

export const calendar_editLiturgicalText_Api = {
  backend: `Route::post('calendars/calendar-liturgical-text/{id}/edit', 'CalendarController@editLiturgicalText');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar-liturgical-text/:id/edit',
  method: 'POST',
  paramsFields: [],
  schema: calendarLiturgicalTextSchema,
  transform: createTransform(calendarLiturgicalTextSchema, 'data'),
}

export const calendar_deleteLiturgicalText_Api = {
  backend: `Route::post('calendars/calendar-liturgical-text/{id}/delete', 'CalendarController@deleteLiturgicalText');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar-liturgical-text/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: calendarLiturgicalTextSchema,
  transform: createTransform(calendarLiturgicalTextSchema, 'data'),
}
export const calendar_getLiturgicalText_Api = {
  backend: `Route::get('calendars/calendar-liturgical-text/{id}/get', 'CalendarController@getLiturgicalText');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar-liturgical-text/:id/get',
  method: 'GET',
  paramsFields: [],
  schema: calendarLiturgicalTextSchema,
  transform: createTransform(calendarLiturgicalTextSchema, 'data'),
}


export const calendar_getCalendarLiturgicalEvents_Api = {
  backend: `Route::get('calendars/calendar/{calendar_id}/calendar-liturgical-event/gets', 'CalendarController@getCalendarLiturgicalEvents');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar/:calendar_id/calendar-liturgical-event/gets',
  method: 'GET',
  paramsFields: [],
  schema: calendarLiturgicalEventSchema,
  transform: createListTransform(calendarLiturgicalEventSchema),
}

export const calendar_createLiturgicalEvent_Api = {
  backend: `Route::post('calendars/calendar/{calendar_id}/calendar-liturgical-event/create', 'CalendarController@createLiturgicalEvent');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar/:calendar_id/calendar-liturgical-event/create',
  method: 'POST',
  paramsFields: [],
  schema: calendarLiturgicalEventSchema,
  transform: createTransform(calendarLiturgicalEventSchema, 'data'),
}

export const calendar_editLiturgicalEvent_Api = {
  backend: `Route::post('calendars/calendar-liturgical-event/{id}/edit', 'CalendarController@editLiturgicalEvent');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar-liturgical-event/:id/edit',
  method: 'POST',
  paramsFields: [],
  schema: calendarLiturgicalEventSchema,
  transform: createTransform(calendarLiturgicalEventSchema, 'data'),
}

export const calendar_deleteLiturgicalEvent_Api = {
  backend: `Route::post('calendars/calendar-liturgical-event/{id}/delete', 'CalendarController@deleteLiturgicalEvent');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar-liturgical-event/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: calendarLiturgicalEventSchema,
  transform: createTransform(calendarLiturgicalEventSchema, 'data'),
}


export const calendar_getLiturgicalEvent_Api = {
  backend: `Route::get('calendars/calendar-liturgical-event/{id}/get', 'CalendarController@getLiturgicalEvent');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar-liturgical-event/:id/get',
  method: 'GET',
  paramsFields: [],
  schema: calendarLiturgicalEventSchema,
  transform: createTransform(calendarLiturgicalEventSchema, 'data'),
}

export const calendar_getTopicOnDate_Api = {
  backend: `Route::get('calendars/calendar/get-current-date', 'CalendarController@getTopicOnDate');`,
  root: API_ROOT_URL,
  path: '/calendars/calendar/get-current-date',
  method: 'GET',
}
